enum DayGridScenario {
    DayView,
    ConflictsView,
}

export default DayGridScenario;
